module.exports = __webpack_public_path__ + "static/img/newsee.74e1b5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/newsee.png
// module id = WrIl
// module chunks = 45